import {
  vetChatPetBirthdateAddedSegmentSchema,
  VetChatPetBirthdateAddedSchema,
  vetChatPetBreedAddedSegmentSchema,
  VetChatPetBreedAddedSchema,
  vetChatPetNameAddedSegmentSchema,
  VetChatPetNameAddedSchema,
  vetChatPetWeightAddedSegmentSchema,
  VetChatPetWeightAddedSchema,
} from '../../utils/validation-schemas/segment/vet-chat-landing';

export const vetChatPetBirthdateAddedSegment = ({
  birthday,
}) => vetChatPetBirthdateAddedSegmentSchema.cast({
  event: 'Vet Chat Pet Birthdate Added',
  properties: {
    birthday,
  },
} as VetChatPetBirthdateAddedSchema);

export const vetChatPetBreedAddedSegment = ({
  breed,
}) => vetChatPetBreedAddedSegmentSchema.cast({
  event: 'Vet Chat Pet Breed Added',
  properties: {
    breed,
  },
} as VetChatPetBreedAddedSchema);

export const vetChatPetNameAddedSegment = ({
  name,
}) => vetChatPetNameAddedSegmentSchema.cast({
  event: 'Vet Chat Pet Name Added',
  properties: {
    name,
  },
} as VetChatPetNameAddedSchema);

export const vetChatPetWeightAddedSegment = ({
  weight,
}) => vetChatPetWeightAddedSegmentSchema.cast({
  event: 'Vet Chat Pet Weight Added',
  properties: {
    weight,
  },
} as VetChatPetWeightAddedSchema);
